<template>
  <b-row class="header">
    <b-col lg="6">
      <breadcrumb style="margin-left: 15px"
      />
    </b-col>
    <b-col lg="6">
    </b-col>
    <dashboard-selector v-if="['TrackerDashboard','Tracker','Dashboard'].includes( $route.name )">
    </dashboard-selector>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardSelector from "@/components/modules/new-dashboard/dashboard-selector.vue";
import Breadcrumb from "./_template-breadcrumb.vue";

export default {
  name: "BreadcrumbHeader",
  components: { DashboardSelector, Breadcrumb },
  methods:{
  },
  computed: {
    ...mapGetters(["getUserAccount"]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/variables.scss";
.header{
  height: 50px;
  background: #d9e6f0;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
}
.snapshot-selectors {
  position: relative;
  top: 8px;
}
</style>
